import { configQuery, getFeatureEnabled, getTrackingService, RoutablePage, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __spreadArray, __assign, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Watch, Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { USER_JURISDICTION_QUERY, Feature, BALANCE_UPDATED, USER_PROFILE_DATA, BALANCE_QUERY, BALANCE_FIAT_CURRENCY_QUERY, USER_QUERY, UPDATE_USER_STATUS } from '@gig/magic-messages';
import { CoreXMediatorType } from '@gig/magic-sdk/dist/adapter/responsiblegaming/createUserTransactionLimit';
import { Jurisdiction } from '@gig/magic-jurisdictions/dist/jurisdictions.constants';
import { CoreXTransacationStatus, CoreXOperationType } from '@gig/magic-sdk/dist/adapter/users/getUserTransactionsHistory';
import { ListenMessageType, LogActionEventName } from '@gig/magic-galleon';
import CashierMixin from '../../mixins/cashier.mixin.js';

var WITHDRAWALS_DAYS_AGO_LIMIT = 100;
var WITHDRAWALS_REQUEST_SIZE = 15;
var WalletContent = /** @class */ (function (_super) {
    __extends(WalletContent, _super);
    function WalletContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showProtectedFunds = false;
        _this.isSubmittingLastInsolvencyReviewOnUtc = false;
        _this.depositInfo = null;
        _this.isWalletMounted = false;
        _this.walletView = '';
        _this.balanceSubscription = undefined;
        _this.magicProfileSubscription = undefined;
        _this.firstDepositComplete = false;
        // We checked depositCount on a deposit attempt. Because some deposits can be success very quickly,
        // and we need to know the count of success before the next success deposit
        _this.depositCount = 0;
        _this.pendingWithdrawalsOffset = 0;
        _this.profile = undefined;
        return _this;
    }
    WalletContent.prototype.hasCustomContent = function (slot) {
        return this.$slots[slot];
    };
    WalletContent.prototype.onLoad = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.initiateWallet()];
                    case 1:
                        _a.sent();
                        this.applyStyles();
                        this.updateView();
                        this.isWalletMounted = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    WalletContent.prototype.initiateWallet = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.initiateWalletConfig()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.initiateWalletTranslations()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.initiateDepositBonuses()];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.initiateTransactionsHistory()];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.initiatePendingWithdrawals()];
                    case 5:
                        _a.sent();
                        return [4 /*yield*/, this.initiateFeatureFlags()];
                    case 6:
                        _a.sent();
                        return [4 /*yield*/, this.initiateWalletBalance()];
                    case 7:
                        _a.sent();
                        return [4 /*yield*/, this.initiateWalletProfile()];
                    case 8:
                        _a.sent();
                        return [4 /*yield*/, this.initiateDepositParams()];
                    case 9:
                        _a.sent();
                        return [4 /*yield*/, this.fetchMagicPaymentMethods()];
                    case 10:
                        _a.sent();
                        return [4 /*yield*/, this.initiateLastInsolvencyReviewOnUtc()];
                    case 11:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    WalletContent.prototype.initiateLastInsolvencyReviewOnUtc = function () {
        return __awaiter(this, void 0, void 0, function () {
            var profileData, isUnderUK, lastInsolvencyReview, jurisdictionCode, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, magic.methods.users.getUserProfile()];
                    case 1:
                        profileData = _a.sent();
                        if (!(profileData === null || profileData === void 0 ? void 0 : profileData.consents)) {
                            return [2 /*return*/];
                        }
                        isUnderUK = false;
                        lastInsolvencyReview = profileData.consents.lastInsolvencyReviewOnUtc;
                        if (!(lastInsolvencyReview === null ||
                            lastInsolvencyReview === undefined)) return [3 /*break*/, 3];
                        return [4 /*yield*/, window.queryBus.query(USER_JURISDICTION_QUERY)];
                    case 2:
                        jurisdictionCode = _a.sent();
                        isUnderUK = jurisdictionCode === Jurisdiction.UKGC;
                        _a.label = 3;
                    case 3:
                        this.showProtectedFunds = !lastInsolvencyReview && isUnderUK;
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        console.error('Failed to fetch profileData', error_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    WalletContent.prototype.initiateDepositBonuses = function () {
        return __awaiter(this, void 0, void 0, function () {
            var language, bonuses, depositBonusesToDisplay;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        language = this.magicConfig.language;
                        return [4 /*yield*/, magic.methods.promotions.filter('deposit', language, false)];
                    case 1:
                        bonuses = _a.sent();
                        return [4 /*yield*/, configQuery('depositBonusesToDisplay')];
                    case 2:
                        depositBonusesToDisplay = _a.sent();
                        this.dispatchEvent(ListenMessageType.DepositBonuses, {
                            bonuses: bonuses,
                            depositBonusesToDisplay: depositBonusesToDisplay,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    WalletContent.prototype.initiateDepositParams = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.lockedAmount) {
                    this.dispatchEvent(ListenMessageType.DepositParams, {
                        sweepstakesShopItemId: this.sweepstakesShopItemId,
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    WalletContent.prototype.fetchMagicPaymentMethods = function () {
        return __awaiter(this, void 0, void 0, function () {
            var shouldFetchMagicConfig, methods;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getFeatureEnabled(Feature.ENHANCED_GALLEON_CASHIER_CONFIGURATION)];
                    case 1:
                        shouldFetchMagicConfig = _a.sent();
                        if (!shouldFetchMagicConfig) return [3 /*break*/, 3];
                        return [4 /*yield*/, magic.methods.wallet.getGalleonPaymentMethods()];
                    case 2:
                        methods = _a.sent();
                        this.dispatchEvent(ListenMessageType.InitMagicPaymentMethods, methods);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WalletContent.prototype.fetchTransactions = function (transactionsConfig) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var daysAgo, size, _b, offset, type, message, operationType, currentDate, someDaysAgo, params, res, transactions, pendingStatuses, filteredTransactions;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        daysAgo = transactionsConfig.daysAgo, size = transactionsConfig.size, _b = transactionsConfig.offset, offset = _b === void 0 ? 0 : _b, type = transactionsConfig.type;
                        message = type === 'deposit'
                            ? ListenMessageType.MonthlyTransactions
                            : ListenMessageType.PendingWithdrawals;
                        operationType = type === 'deposit'
                            ? CoreXOperationType.CREDIT
                            : CoreXOperationType.DEBIT;
                        currentDate = new Date();
                        someDaysAgo = new Date(currentDate);
                        someDaysAgo.setDate(currentDate.getDate() - daysAgo);
                        params = {
                            size: size,
                            from: offset,
                            dateFrom: someDaysAgo.getTime(),
                            dateTo: Date.now(),
                            mediatorType: CoreXMediatorType.MONETARY,
                            operationType: operationType,
                        };
                        return [4 /*yield*/, magic.methods.users.getUserTransactionsHistory(params)];
                    case 1:
                        res = _c.sent();
                        transactions = ((_a = res === null || res === void 0 ? void 0 : res.ActivityUserWalletTransactions) === null || _a === void 0 ? void 0 : _a.map(function (w) { return ({
                            id: w.Id,
                            additionalProperties: w.Payload.Transaction.Current.AdditionalProperties,
                            currency: w.Payload.CurrencyCode,
                            ts: w.TimestampEpoch,
                            amount: w.Payload.Amount,
                            status: w.Payload.Transaction.Current.Status,
                        }); })) || [];
                        pendingStatuses = [
                            CoreXTransacationStatus.PENDING_AUTHORIZATION,
                            CoreXTransacationStatus.PENDING_REVERSAL,
                            CoreXTransacationStatus.PENDING_VALIDATION,
                        ];
                        filteredTransactions = __spreadArray([], transactions);
                        if (message === ListenMessageType.PendingWithdrawals) {
                            this.pendingWithdrawalsOffset += transactions.length;
                            filteredTransactions = transactions.filter(function (transaction) {
                                return pendingStatuses.includes(transaction.status);
                            });
                        }
                        this.dispatchEvent(message, {
                            offset: offset,
                            isPendingWithdrawals: true,
                            transactions: filteredTransactions,
                            isLast: transactions.length < size,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    WalletContent.prototype.initiateTransactionsHistory = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.fetchTransactions({
                    daysAgo: 30,
                    size: 3,
                    offset: 0,
                    type: 'deposit',
                });
                return [2 /*return*/];
            });
        });
    };
    WalletContent.prototype.initiatePendingWithdrawals = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isPendingWithdrawals;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getFeatureEnabled(Feature.CASHIER_PENDING_WITHDRAWALS)];
                    case 1:
                        isPendingWithdrawals = _a.sent();
                        if (!isPendingWithdrawals) {
                            this.dispatchEvent(ListenMessageType.PendingWithdrawals, {
                                isPendingWithdrawals: false,
                                withdrawals: [],
                            });
                            return [2 /*return*/];
                        }
                        this.fetchTransactions({
                            daysAgo: WITHDRAWALS_DAYS_AGO_LIMIT,
                            size: WITHDRAWALS_REQUEST_SIZE,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    WalletContent.prototype.initiateFeatureFlags = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isClosedLoopEnabled, isMethodRemovalEnabled, skipIntermediateRedirectStep, paysafeSkrillClosedLoop, paysafeSkrillAllowSeveralWithdrawalAccounts, enhancedGalleonCashierConfiguration, triggerKycVerificationsBeforeEnteringRedemptionShop, triggerKycVerificationsBeforeSelectingShopRedemptionMethod, triggerKycVerificationsBeforeEnteringCoinShop, triggerKycVerificationsBeforeSelectingCoinShopPurchaseMethod;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getFeatureEnabled(Feature.PAYMENTS_CLOSED_LOOP)];
                    case 1:
                        isClosedLoopEnabled = _a.sent();
                        return [4 /*yield*/, getFeatureEnabled(Feature.WALLET_METHOD_REMOVAL)];
                    case 2:
                        isMethodRemovalEnabled = _a.sent();
                        return [4 /*yield*/, getFeatureEnabled(Feature.SKIP_INTERMIDIATE_REDIRECT_STEP)];
                    case 3:
                        skipIntermediateRedirectStep = _a.sent();
                        return [4 /*yield*/, getFeatureEnabled(Feature.PAYSAFE_SKRILL_CLOSED_LOOP)];
                    case 4:
                        paysafeSkrillClosedLoop = _a.sent();
                        return [4 /*yield*/, getFeatureEnabled(Feature.PAYSAFE_SKRILL_ALLOW_SEVERAL_WITHDRAWAL_ACCOUNTS)];
                    case 5:
                        paysafeSkrillAllowSeveralWithdrawalAccounts = _a.sent();
                        return [4 /*yield*/, getFeatureEnabled(Feature.ENHANCED_GALLEON_CASHIER_CONFIGURATION)];
                    case 6:
                        enhancedGalleonCashierConfiguration = _a.sent();
                        return [4 /*yield*/, getFeatureEnabled(Feature.TRIGGER_KYC_VERIFICATIONS_BEFORE_ENTERING_REDEMPTION_SHOP)];
                    case 7:
                        triggerKycVerificationsBeforeEnteringRedemptionShop = _a.sent();
                        return [4 /*yield*/, getFeatureEnabled(Feature.TRIGGER_KYC_VERIFICATIONS_BEFORE_SELECTING_SHOP_REDEMPTION_METHOD)];
                    case 8:
                        triggerKycVerificationsBeforeSelectingShopRedemptionMethod = _a.sent();
                        return [4 /*yield*/, getFeatureEnabled(Feature.TRIGGER_KYC_VERIFICATIONS_BEFORE_ENTERING_COIN_SHOP)];
                    case 9:
                        triggerKycVerificationsBeforeEnteringCoinShop = _a.sent();
                        return [4 /*yield*/, getFeatureEnabled(Feature.TRIGGER_KYC_VERIFICATIONS_BEFORE_SELECTING_COIN_SHOP_PURCHASE_METHOD)];
                    case 10:
                        triggerKycVerificationsBeforeSelectingCoinShopPurchaseMethod = _a.sent();
                        this.dispatchEvent(ListenMessageType.UpdateFeatureFlags, {
                            isClosedLoopEnabled: isClosedLoopEnabled,
                            isMethodRemovalEnabled: isMethodRemovalEnabled,
                            skrillClosedLoop: paysafeSkrillClosedLoop,
                            paysafeSkrillAllowSeveralWithdrawalAccounts: paysafeSkrillAllowSeveralWithdrawalAccounts,
                            skipIntermediateRedirectStep: skipIntermediateRedirectStep,
                            enhancedGalleonCashierConfiguration: enhancedGalleonCashierConfiguration,
                            triggerKycVerificationsBeforeEnteringRedemptionShop: triggerKycVerificationsBeforeEnteringRedemptionShop,
                            triggerKycVerificationsBeforeSelectingShopRedemptionMethod: triggerKycVerificationsBeforeSelectingShopRedemptionMethod,
                            triggerKycVerificationsBeforeEnteringCoinShop: triggerKycVerificationsBeforeEnteringCoinShop,
                            triggerKycVerificationsBeforeSelectingCoinShopPurchaseMethod: triggerKycVerificationsBeforeSelectingCoinShopPurchaseMethod,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    WalletContent.prototype.initiateWalletBalance = function () {
        return __awaiter(this, void 0, void 0, function () {
            var balanceEvent;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getBalanceEvent()];
                    case 1:
                        balanceEvent = _a.sent();
                        this.dispatchEvent(ListenMessageType.UpdateBalance, balanceEvent);
                        this.balanceSubscription = window.eventBus.subscribe(BALANCE_UPDATED, function () { return __awaiter(_this, void 0, void 0, function () {
                            var balanceEvent;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.getBalanceEvent()];
                                    case 1:
                                        balanceEvent = _a.sent();
                                        this.dispatchEvent(ListenMessageType.UpdateBalance, balanceEvent);
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    WalletContent.prototype.initiateWalletProfile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.getProfileEventData()];
                    case 1:
                        _a.profile = _b.sent();
                        this.dispatchEvent(ListenMessageType.UpdateProfile, {
                            profile: this.profile,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    WalletContent.prototype.updateWalletProfile = function (profile) {
        var resultProfile = __assign(__assign({}, (this.profile || {})), profile);
        this.dispatchEvent(ListenMessageType.UpdateProfile, {
            profile: resultProfile,
        });
    };
    WalletContent.prototype.getProfileEventData = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __awaiter(this, void 0, void 0, function () {
            var userProfile, corexProfile, user, resultPhone, profile;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0: return [4 /*yield*/, this.getUserProfile()];
                    case 1:
                        userProfile = _l.sent();
                        return [4 /*yield*/, this.getProfileCoreX(true)];
                    case 2:
                        corexProfile = _l.sent();
                        // manual deposit log handling checking the deposit count
                        this.depositCount = corexProfile.depositCount;
                        user = userProfile.user;
                        resultPhone = (((_a = user.mobileNumber) === null || _a === void 0 ? void 0 : _a.prefix) || '') +
                            (((_b = user.mobileNumber) === null || _b === void 0 ? void 0 : _b.number) || '');
                        if (!((_c = user.mobileNumber) === null || _c === void 0 ? void 0 : _c.number)) {
                            resultPhone =
                                (((_d = user.telephoneNumber) === null || _d === void 0 ? void 0 : _d.prefix) || '') +
                                    (((_e = user.telephoneNumber) === null || _e === void 0 ? void 0 : _e.number) || '');
                        }
                        profile = {
                            customer: {
                                firstName: user.givenName,
                                lastName: user.familyName,
                                middleName: user.additionalName,
                                email: user.email,
                                phone: resultPhone,
                                dateOfBirth: {
                                    // Parse birthdate and extract components, assuming format is YYYY-MM-DD
                                    day: new Date(user.birthDate).getDate(),
                                    month: new Date(user.birthDate).getMonth() + 1,
                                    year: new Date(user.birthDate).getFullYear(),
                                },
                            },
                            billingAddress: {
                                street: (_f = user.address) === null || _f === void 0 ? void 0 : _f.streetAddress,
                                city: (_g = user.address) === null || _g === void 0 ? void 0 : _g.addressLocality,
                                zip: (_h = user.address) === null || _h === void 0 ? void 0 : _h.postalCode,
                                country: (_j = user.address) === null || _j === void 0 ? void 0 : _j.addressCountry,
                                state: (_k = user.address) === null || _k === void 0 ? void 0 : _k.addressRegion,
                            },
                            depositCount: this.depositCount,
                        };
                        return [2 /*return*/, profile];
                }
            });
        });
    };
    WalletContent.prototype.getUserProfile = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.userProfile) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, window.queryBus.query(USER_PROFILE_DATA)];
                    case 1:
                        _a.userProfile = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/, this.userProfile];
                }
            });
        });
    };
    WalletContent.prototype.applyStyles = function () {
        var walletRef = this.$refs.wallet;
        var styleSheet = new CSSStyleSheet();
        // @ts-ignore
        styleSheet.replaceSync(window.cashierStyles);
        // @ts-ignore
        walletRef.shadowRoot.adoptedStyleSheets.push(styleSheet);
    };
    WalletContent.prototype.getBalanceEvent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currencyCode, balance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, window.queryBus.query(BALANCE_FIAT_CURRENCY_QUERY)];
                    case 1:
                        currencyCode = _a.sent();
                        return [4 /*yield*/, window.queryBus.query(BALANCE_QUERY, currencyCode)];
                    case 2:
                        balance = _a.sent();
                        return [2 /*return*/, {
                                balance: {
                                    currencyCode: currencyCode,
                                    balance: +balance.balance,
                                    limit: 0,
                                    withdrawable: balance.withdrawable >= 0
                                        ? +balance.withdrawable
                                        : +balance.balance,
                                },
                            }];
                }
            });
        });
    };
    WalletContent.prototype.destroyed = function () {
        var _a, _b, _c;
        (_a = this.languageSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.balanceSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
        (_c = this.magicProfileSubscription) === null || _c === void 0 ? void 0 : _c.unsubscribe();
        if (this.tokenInterval) {
            clearInterval(this.tokenInterval);
        }
    };
    WalletContent.prototype.updateView = function () {
        this.dispatchEvent(ListenMessageType.UpdateView, {
            view: this.view,
            lockedAmount: this.lockedAmount,
        });
    };
    WalletContent.prototype.dispatchEvent = function (name, detail) {
        var walletRef = this.$refs.wallet;
        var viewEvent = new CustomEvent(name, { detail: detail });
        walletRef.dispatchEvent(viewEvent);
    };
    WalletContent.prototype.onViewChange = function (event) {
        this.walletView = event.detail;
        return this.walletView;
    };
    WalletContent.prototype.onLogMessage = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var detail, _a, eventData, depositInfo, profile, eventData, eventData, depositInfo, eventData, withdrawalInfo, eventData, withdrawalInfo, eventData, withdrawalInfo;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        detail = event.detail;
                        _a = detail.type;
                        switch (_a) {
                            case LogActionEventName.DepositIntent: return [3 /*break*/, 1];
                            case LogActionEventName.WithdrawalIntent: return [3 /*break*/, 2];
                            case LogActionEventName.DepositAttempt: return [3 /*break*/, 3];
                            case LogActionEventName.DepositSuccess: return [3 /*break*/, 5];
                            case LogActionEventName.DepositError: return [3 /*break*/, 6];
                            case LogActionEventName.WithdrawalAttempt: return [3 /*break*/, 7];
                            case LogActionEventName.WithdrawalSuccess: return [3 /*break*/, 8];
                            case LogActionEventName.WithdrawalError: return [3 /*break*/, 9];
                        }
                        return [3 /*break*/, 10];
                    case 1:
                        {
                            getTrackingService().trackDepositIntent();
                            return [3 /*break*/, 10];
                        }
                    case 2:
                        {
                            getTrackingService().trackWithdrawalIntent();
                            return [3 /*break*/, 10];
                        }
                    case 3:
                        eventData = detail.params;
                        depositInfo = {
                            amount: eventData.amount,
                            currency: eventData.currency,
                            method: eventData.method,
                            bonusCode: eventData.bonusCode,
                        };
                        getTrackingService().trackDepositAttempt(depositInfo);
                        return [4 /*yield*/, this.getProfileCoreX(true)];
                    case 4:
                        profile = _b.sent();
                        // manual deposit log handling checking the deposit count
                        this.depositCount = profile.depositCount;
                        this.updateWalletProfile({
                            depositsCount: this.depositCount,
                        });
                        return [3 /*break*/, 10];
                    case 5:
                        {
                            eventData = detail.params;
                            this.depositInfo = {
                                amount: eventData.amount,
                                currency: eventData.currency,
                                method: eventData.method,
                                bonusCode: eventData.bonusCode,
                            };
                            if (!this.firstDepositComplete && this.depositCount === 0) {
                                this.handleFirstDeposit();
                                this.firstDepositComplete = true;
                            }
                            else {
                                this.handleSubsequentDeposit();
                            }
                            return [3 /*break*/, 10];
                        }
                    case 6:
                        {
                            eventData = detail.params;
                            depositInfo = {
                                amount: eventData.amount,
                                currency: eventData.currency,
                                method: eventData.method,
                                bonusCode: eventData.bonusCode,
                            };
                            getTrackingService().trackDepositError(depositInfo);
                            return [3 /*break*/, 10];
                        }
                    case 7:
                        {
                            eventData = detail.params;
                            withdrawalInfo = {
                                amount: eventData.amount,
                                currency: eventData.currency,
                                method: eventData.method,
                                transactionId: eventData.transactionId,
                            };
                            getTrackingService().trackWithdrawalAttempt(withdrawalInfo);
                            return [3 /*break*/, 10];
                        }
                    case 8:
                        {
                            eventData = detail.params;
                            withdrawalInfo = {
                                amount: eventData.amount,
                                currency: eventData.currency,
                                method: eventData.method,
                                transactionId: eventData.transactionId,
                            };
                            getTrackingService().trackWithdrawalSuccess(withdrawalInfo);
                            return [3 /*break*/, 10];
                        }
                    case 9:
                        {
                            eventData = detail.params;
                            withdrawalInfo = {
                                amount: eventData.amount,
                                currency: eventData.currency,
                                method: eventData.method,
                                transactionId: eventData.transactionId,
                            };
                            getTrackingService().trackWithdrawalError(withdrawalInfo);
                            return [3 /*break*/, 10];
                        }
                    case 10: return [2 /*return*/, event.detail];
                }
            });
        });
    };
    /**
     * Retrieves the core profile data for Magic's user.
     * If the profile is not already cached, or if the `force` parameter is set to `true`,
     * this method will fetch the profile data from the Magic service.
     * @param {boolean} force - Optional. If `true`, forces a fresh retrieval of the profile data, bypassing the cache.
     * @private
     */
    WalletContent.prototype.getProfileCoreX = function (force) {
        if (force === void 0) { force = false; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!force) return [3 /*break*/, 2];
                        return [4 /*yield*/, window.commandBus.publish(UPDATE_USER_STATUS)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, window.queryBus.query(USER_QUERY)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    WalletContent.prototype.onDepositResult = function (event) {
        return event.detail;
    };
    WalletContent.prototype.onWithdrawResult = function (event) {
        return event.detail;
    };
    WalletContent.prototype.handleFirstDeposit = function () {
        var isWayBack = this.isRegisteredWayBack();
        if (isWayBack) {
            getTrackingService().trackFirstTimeDeposit(this.depositInfo);
        }
        else {
            getTrackingService().trackNewDepositingCustomer(this.depositInfo);
        }
    };
    WalletContent.prototype.isRegisteredWayBack = function (daysCount) {
        if (daysCount === void 0) { daysCount = 1; }
        var user = magic.session.getUser();
        // to support backward compatibility of the createdDate format with no 'Z'
        var formattedUserDate = user.createdDate.endsWith('Z')
            ? user.createdDate
            : user.createdDate + 'Z';
        var createdDateObj = new Date(formattedUserDate);
        var oneDayInMilliseconds = 24 * 60 * 60 * 1000;
        var currentDate = new Date();
        // Compare the difference in time to one day
        var totalMilliseconds = oneDayInMilliseconds * daysCount;
        var timeGap = currentDate.getTime() - createdDateObj.getTime();
        return timeGap >= totalMilliseconds;
    };
    WalletContent.prototype.handleSubsequentDeposit = function () {
        if (this.depositInfo) {
            getTrackingService().trackDeposit(this.depositInfo);
        }
    };
    WalletContent.prototype.watchViewUpdate = function (view) {
        if (view !== this.walletView) {
            this.updateView();
        }
    };
    WalletContent.prototype.onWithdrawals = function (event) {
        var _a, _b, _c;
        var offset = (_c = (_a = this.pendingWithdrawalsOffset) !== null && _a !== void 0 ? _a : (_b = event.detail) === null || _b === void 0 ? void 0 : _b.withdrawalsCount) !== null && _c !== void 0 ? _c : 0;
        this.fetchTransactions({
            daysAgo: WITHDRAWALS_DAYS_AGO_LIMIT,
            size: WITHDRAWALS_REQUEST_SIZE,
            offset: offset,
        });
    };
    WalletContent.prototype.agreeClickHandler = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currentDate, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        this.isSubmittingLastInsolvencyReviewOnUtc = true;
                        currentDate = new Date().toISOString();
                        return [4 /*yield*/, magic.methods.users.updateUserProfile({
                                lastInsolvencyReviewOnUtc: currentDate,
                            })];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, window.commandBus.publish(UPDATE_USER_STATUS)];
                    case 2:
                        _a.sent();
                        this.showProtectedFunds = false;
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        console.error("error: ", e_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.isSubmittingLastInsolvencyReviewOnUtc = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    WalletContent.prototype.goToGames = function () {
        this.routeTo({ route: RoutablePage.GAMES });
    };
    WalletContent.prototype.openTnc = function () {
        this.routeTo({ route: RoutablePage.TNC });
    };
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], WalletContent.prototype, "view", void 0);
    __decorate([
        Prop(Number),
        __metadata("design:type", Number)
    ], WalletContent.prototype, "lockedAmount", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], WalletContent.prototype, "sweepstakesShopItemId", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], WalletContent.prototype, "quickDeposit", void 0);
    __decorate([
        Emit('change-view'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [CustomEvent]),
        __metadata("design:returntype", void 0)
    ], WalletContent.prototype, "onViewChange", null);
    __decorate([
        Emit('deposit-result'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [CustomEvent]),
        __metadata("design:returntype", void 0)
    ], WalletContent.prototype, "onDepositResult", null);
    __decorate([
        Emit('withdraw-result'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [CustomEvent]),
        __metadata("design:returntype", void 0)
    ], WalletContent.prototype, "onWithdrawResult", null);
    __decorate([
        Watch('view'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], WalletContent.prototype, "watchViewUpdate", null);
    WalletContent = __decorate([
        Component({
            name: 'wallet-content',
        })
    ], WalletContent);
    return WalletContent;
}(Mixins(MagicConfigMixin, CashierMixin)));

export default WalletContent;
